<div [formGroup]="formGroup">
    <h2>{{ _opportunity.opportunityName }}</h2>

    <div style="display: flex; gap: 10px">
        <mat-form-field>
            <mat-label>Status</mat-label>
            <mat-select formControlName="status" [disabled]="true">
                @for (status of OpportunityStatuses | keyvalue; track status) {
                    <mat-option [value]="status.value">
                        {{ status.value }}
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>

        <mat-form-field style="min-width: 250px">
            <mat-label>Opportunity stage</mat-label>
            <mat-select formControlName="opportunityStage" required>
                @for (stage of OpportunityStages | keyvalue; track stage) {
                    <mat-option [value]="stage.value">
                        {{ stage.value }}
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>

        @if (isLost) {
            <mat-form-field style="min-width: 250px">
                <mat-label>Loss reason</mat-label>
                <mat-select formControlName="lostBecause" required>
                    @for (stage of OpportunityLossReasons | keyvalue; track stage) {
                        <mat-option [value]="stage.value">
                            {{ stage.value }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        }
    </div>

    <div>
        <mat-form-field style="flex-grow: 1">
            <mat-label>Potential closure year</mat-label>
            <input matInput type="number" formControlName="potentialClosureYear" required/>

            @if (formGroup.get('potentialClosureYear').hasError('required')) {
                <mat-error>
                    Required field
                </mat-error>
            }
        </mat-form-field>

        <mat-form-field style="min-width: 250px">
            <mat-label>Potential closure - Semester</mat-label>
            <mat-select formControlName="potentialClosureQuarter" required>
                <mat-option [value]="'Semestre 1'">1° Semestre</mat-option>
                <mat-option [value]="'Semestre 2'">2° Semestre</mat-option>
            </mat-select>

            @if (formGroup.get('potentialClosureQuarter').hasError('required')) {
                <mat-error>
                    Required field
                </mat-error>
            }
        </mat-form-field>
        <mat-form-field>
            <mat-label>Revision number</mat-label>
            <mat-select formControlName="revisionNumber" required>
                @for (i of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]; track i) {
                    <mat-option [value]="i">{{ i }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>

    <div style="display: flex; gap:10px">
        <mat-form-field>
            <mat-label>Proposal sent on</mat-label>
            <input matInput formControlName="proposalSentOn" [matDatepicker]="proposalSentOnPicker" (click)="proposalSentOnPicker.open()"/>
            <mat-datepicker-toggle matSuffix [for]="proposalSentOnPicker"></mat-datepicker-toggle>
            <mat-datepicker #proposalSentOnPicker></mat-datepicker>
        </mat-form-field>

        @if (formGroup.get('opportunityStage').value === OpportunityStages.RICHIESTA_DI_OFFERTA) {
            <mat-form-field>
                <mat-label>Proposal requested</mat-label>
                <input matInput formControlName="proposalRequested" [matDatepicker]="proposalRequestedPicker" (click)="proposalRequestedPicker.open()"/>
                <mat-datepicker-toggle matSuffix [for]="proposalRequestedPicker"></mat-datepicker-toggle>
                <mat-datepicker #proposalRequestedPicker></mat-datepicker>
            </mat-form-field>
        }

        <mat-form-field>
            <mat-label>Follow-up date</mat-label>
            <input matInput formControlName="followUpDate" [matDatepicker]="followUpDatePicker" (click)="followUpDatePicker.open()" required/>
            <mat-datepicker-toggle matSuffix [for]="followUpDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #followUpDatePicker></mat-datepicker>
        </mat-form-field>

        @if (formGroup.get('status').value === OpportunityStatuses.IN_PROGRESS) {
            <mat-form-field>
                <mat-label>Next follow-up date</mat-label>
                <input matInput formControlName="nextFollowUpDate" [matDatepicker]="nextFollowUpDatePicker" (click)="nextFollowUpDatePicker.open()"
                       [required]="formGroup.get('status').value === OpportunityStatuses.IN_PROGRESS"
                />
                <mat-datepicker-toggle matSuffix [for]="nextFollowUpDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #nextFollowUpDatePicker></mat-datepicker>
            </mat-form-field>
        }
    </div>

    <div style="display: flex; gap:10px">
        <mat-form-field>
            <mat-label>Currency</mat-label>
            <mat-select formControlName="currency">
                <mat-option value='EUR'>EUR</mat-option>
                <mat-option value='USD'>USD</mat-option>
            </mat-select>
        </mat-form-field>

        @if (formGroup.get('currency').value === 'EUR') {
            <mat-form-field>
                <mat-label>Forecast amount ITA</mat-label>
                <input matInput formControlName="forecastAmountITA" type="number"/>
            </mat-form-field>
        }

        @if (formGroup.get('currency').value === 'USD') {
            <mat-form-field>
                <mat-label>Forecast amount USA</mat-label>
                <input matInput formControlName="forecastAmountUSA" type="number"/>
            </mat-form-field>
        }
    </div>

    <div style="display: flex">
        <mat-form-field style="flex-grow: 1">
            <mat-label>Next steps</mat-label>
            <textarea
                    matInput
                    formControlName="nextSteps"
                    required
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="1"
            ></textarea>
        </mat-form-field>
    </div>
</div>
